<nb-card>
  <nb-card-header>
    <div class="menu-buttons"></div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h1>
              <strong>
                CÔNG TY TNHH MTV TM DV<br />
                PHONG PHÚ DƯƠNG
              </strong>
            </h1>
          </td>
          <td style="text-align: center">
            <p>
              <u>Chuyên Phân Phối Sỉ & Lẻ:</u> *Ống Nhựa, Phụ Kiện <br />
              Ngành Nước & Thiết Bị Vệ Sinh Cao Cấp<br />
              *Thiết Bị Điện: Dây cáp Cadivi, Daphaco, Bóng đèn<br />
              Rạng Đông, Thiết bị điện Panasonic, Sino, PiPo...
            </p>
          </td>
        </tr>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: left">
            <label> ĐC: {{ shop.address }} </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: left">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: left">
            <label>
              <!-- NH: Sacombank chi nhánh Đồng Khỏi - CTK: Đỗ Ngọc Quyết - TK: 0700
              8971 8242 -->
              {{ shop.description }}
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h1>PHIẾU BÁO GIÁ</h1>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              <b> Ngày:</b>
              {{ receipt.issueDate | date: "dd/MM/yyyy " }}
            </label>

            <label *ngIf="receipt.warehouseName">
              <b>. / Kho:</b>
              {{ receipt.warehouseName }}
            </label>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            >
              <tr>
                <td style="text-align: left; width: 60%">
                  <label>
                    <strong> Khách hàng: </strong> {{ receipt.customerName }}
                  </label>
                </td>
                <td style="text-align: left; width: 40%">
                  <label>
                    <strong> ĐT: </strong> {{ receipt.customerMobile }}
                  </label>
                </td>
              </tr>
              <tr>
                <td style="text-align: left; width: 60%">
                  <strong> {{ "common.address" | translate }} : </strong>
                  {{ receipt.customerAddress }}
                </td>
                <td style="text-align: left; width: 40%">
                  <label>
                    <strong> NVBH: </strong> {{ receipt.employeeSaleName }}
                  </label>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> {{ "common.no" | translate }} </strong>
            </th>
            <!-- <th>
              <strong> {{ "product.code" | translate }} </strong>
            </th> -->
            <th>
              <strong> {{ "product.name" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.unit" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.quantity" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.unitPrice" | translate }} </strong>
            </th>
            <th>
              <strong> CK </strong>
            </th>
            <th>
              <strong> Giá sau CK </strong>
            </th>
            <th>
              <strong> {{ "common.totalAmount" | translate }} </strong>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of receipt?.receiptOrderDetails; let i = index">
            <td>{{ i + 1 }}</td>
            <!-- <td>{{ item.productCode }}</td> -->
            <td style="text-align: left">
              <label
                *ngIf="
                  !item.productColorName || item.productColorName !== 'In Đậm'
                "
              >
                {{ item.productName }}
                <span *ngIf="item.comment">( {{ item.comment }} )</span>
              </label>

              <b
                *ngIf="
                  item.productColorName && item.productColorName === 'In Đậm'
                "
              >
                {{ item.productName }}
                <span *ngIf="item.comment">( {{ item.comment }} )</span>
              </b>
            </td>
            <td style="text-align: left">
              <label
                *ngIf="
                  !item.productColorName || item.productColorName !== 'In Đậm'
                "
              >
                {{ item.productUnitName }}
              </label>
              <b
                *ngIf="
                  item.productColorName && item.productColorName === 'In Đậm'
                "
              >
                {{ item.productUnitName }}
              </b>
            </td>
            <td style="text-align: right">
              <label
                *ngIf="
                  !item.productColorName || item.productColorName !== 'In Đậm'
                "
              >
                {{ item.quantity | number: 0 }}
              </label>
              <b
                *ngIf="
                  item.productColorName && item.productColorName === 'In Đậm'
                "
              >
                {{ item.quantity | number: 0 }}
              </b>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.price | number: 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                <span *ngIf="item.discountPercent > 0"
                  >{{ item.discountPercent.toFixed(1) }}%
                </span>
                <!-- {{ item.discountAmount | number : 0 }} -->
              </label>
            </td>
            <td style="text-align: right">
              <label *ngIf="item.discountPercent > 0">
                {{
                  (
                    item.price -
                    (item.price * item.discountPercent) / 100
                  ).toFixed(0) | number: 0
                }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.amount | number: 0 }}
            </td>
          </tr>

          <tr *ngIf="receipt.discountAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong> {{ "common.netAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.detailAmount | number: 0 }} </strong>
            </td>
          </tr>

          <tr *ngIf="receipt.discountAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong>
                {{ "common.discount" | translate }}
                <span *ngIf="receipt.discountPercent > 0">
                  {{ receipt.discountPercent | number: 0 }}%
                </span>
                :
              </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.discountAmount | number: 0 }}
              </strong>
            </td>
          </tr>

          <tr *ngIf="receipt.vatAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong>
                VAT
                <span *ngIf="receipt.vatPercent > 0">
                  {{ receipt.vatPercent | number: 0 }}%
                </span>
                :
              </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.vatAmount | number: 0 }}
              </strong>
            </td>
          </tr>

          <tr>
            <td colspan="7" style="text-align: right">
              <strong> {{ "common.totalAmount" | translate }}: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.totalAmount | number: 0 }} </strong>
            </td>
          </tr>

          <tr *ngIf="receipt.paymentAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong> Thanh toán: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ receipt.paymentAmount | number: 0 }} </strong>
            </td>
          </tr>
          <tr *ngIf="receipt.paymentAmount > 0">
            <td colspan="7" style="text-align: right">
              <strong> Còn nợ: </strong>
            </td>
            <td style="text-align: right">
              <strong>
                {{ receipt.totalAmount - receipt.paymentAmount | number: 0 }}
              </strong>
            </td>
          </tr>

          <tr>
            <td colspan="8" style="text-align: right">
              <strong> Bằng chữ: </strong>
              <span style="font-style: italic">
                {{ totalAmountText }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="3" class="height-1">
            <strong>
              Chú ý: Sau khi nhận hàng mọi đối chiếu của Quý Khách chỉ có giá
              trị trong vòng 24 giờ
            </strong>
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td style="text-align: center">
            <span>
              Ngày {{ currentDate | date: "dd " }} tháng
              {{ currentDate | date: "MM " }} năm
              {{ currentDate | date: "yyyy " }}</span
            >
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người nhận hàng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Nhận đủ tiền </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <!--- This is hidden using CSS ----->
    <button
      type="button"
      class="btn btn-sm d-none"
      ngxPrint
      printSectionId="print-section"
      styleSheetFile="assets/css/layout-print.css"
      #printBtn
      ngxPrint
    >
      Auto Print
    </button>

    <button
      *ngIf="!printing"
      nbButton
      hero
      shape="semi-round"
      status="info"
      size="medium"
      (click)="print()"
      [disabled]="loading"
      [class.btn-pulse]="loading"
      id="btnPrint"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
